<template>
  <v-card v-if="event" color="grey lighten-4" min-width="350px" flat>
    <v-card-title class="d-flex justify-space-between">
      <span>{{ event.date | formatDate }} <span v-if="event.excluded">(Cancelled)</span></span>

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-card class="mx-auto" max-width="400" width="250" tile>
          <v-list dense>
            <v-list-item-group color="primary">
              <v-list-item disabled>
                <v-list-item-icon class="mr-2">
                  <v-icon>mdi-cancel</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Cancel Occurrence</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item disabled>
                <v-list-item-icon class="mr-2">
                  <v-icon>mdi-pencil</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Edit Occurrence</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="event.recurring" @click="deleteSchedule">
                <v-list-item-icon class="mr-2">
                  <v-icon>mdi-delete-clock</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    Delete Recurring Schedule
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                :to="{
                  name: 'TeacherSchedule',
                  params: { teacherId: event.staffId },
                  query: {
                    scheduleId: event.id,
                    scheduleType: event.type,
                  },
                }"
                v-if="event.recurring"
              >
                <v-list-item-icon class="mr-2">
                  <v-icon>mdi-calendar-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Edit Recurring Schedule</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item disabled v-if="event.recurring && !event.recurringEndDate">
                <v-list-item-icon class="mr-2">
                  <v-icon>mdi-calendar-end</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Set End Date</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-menu>
    </v-card-title>
    <v-card-subtitle v-if="event.recurring">
      Recurring Schedule
      <span v-if="event.recurringEndDate"
        > , ends on {{ event.recurringEndDate | formatDateYear }} </span
      >
    </v-card-subtitle>
    <v-card-subtitle>
      {{ event.staffName }}
    </v-card-subtitle>
    <v-card-text>
      Scheduled from {{ event.start | formatTime }} to
      {{ event.end | formatTime }} for
      {{ event.centerId ? getCenterName(event.centerId):'Unknown Location' }}
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn text color="secondary" @click="$emit('close')"> Close </v-btn>
      <v-spacer />
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
        ...mapGetters(["globalCenter", "myCenters", "getCenterName"]),

    event() {
      return this.value;
    },
  },
  methods: {
    ...mapActions(["addErrorMessage", "addSuccessMessage"]),

    deleteSchedule() {
      const params = {
        schedule_id: this.event.id,
        staff_type: this.event.type,
      };
      this.$axios
        .delete("staff/schedules", { params })
        .then(() => {
          this.addSuccessMessage("Schedule deleted successfully");
          this.$emit('deleted')
        })
        .catch(() => {
          this.addErrorMessage("Error deleting schedule");
        });
    },
  },
};
</script>

<style>
</style>